import React, { useRef, useState, useEffect } from 'react';
import { Button, FormLabel, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ApiUtil from '../../util/ApiUtil';
import ApiPath from '../../util/ApiPath';

const OTPInput = ({ length = 6, handleClick, email }) => {
  const { t } = useTranslation();
  const inputRef = useRef(Array(length).fill(null));
  const [validated, setValidated] = useState(false);
  const [OTP, setOTP] = useState(Array(length).fill(''));
  const [timer, setTimer] = useState(60); // Timer state (60 seconds)
  const [isTimerActive, setIsTimerActive] = useState(true); // To track if the timer is active
  const [msgError, setMsgError] = useState('');
  useEffect(() => {
    // Focus the first input if it exists
    if (!OTP.join('')) {
       inputRef.current[0]?.focus();
    }
    // Timer logic
    let interval = null;
    if (isTimerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setIsTimerActive(false); // Stop the timer when it reaches zero
    }

    return () => clearInterval(interval); // Cleanup on unmount
  }, [isTimerActive, timer,OTP]);

  const handleTextChange = (input, index) => {
    const newPin = [...OTP];
    newPin[index] = input;
    setOTP(newPin);

    if (input.length === 1 && index < length - 1) {
      inputRef.current[index + 1]?.focus(); // Focus next input
    }

    if (input.length === 0 && index > 0) {
      inputRef.current[index - 1]?.focus(); // Focus previous input
    }
  };

  const handleSendCode = async () => {
    await ApiUtil.postApi(ApiPath.FORGET_PASSWORD, { 'email': email }, 'POST');

    // After sending the code, reset the timer
    setTimer(60); // Reset timer to 60 seconds
    setIsTimerActive(true); // Start the timer
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true)

    if (OTP.join('')) {
      const res = await ApiUtil.postApi(ApiPath.VERIFY_CODE, { 'Email': email, "VerifyCode": OTP.join('') },'POST')
      if (res.IsSuccessfull) {
        setValidated(false)
        handleClick('CreatePassword');
      } else {
        setValidated(true);
        setMsgError(t(res.Errors[0].Message))
        
      }
    } else {
      setValidated(true);
      setMsgError(t("Please enter") + ' ' + t('verifyCode'))
    }
  }

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    if (pastedData.length === length && /^[0-9]+$/.test(pastedData)) {
      const newOTP = pastedData.split('');
      setOTP(newOTP);
      newOTP.forEach((char, idx) => {
        if (inputRef.current[idx]) {
          inputRef.current[idx].value = char; // Populate the input fields
        }
      });
    } else {
      setMsgError(t('Invalid paste data. Please paste a valid code.'));
    }
  };
  return (
    <Form onSubmit={handleSubmit}>
      <p className='text-center'>{t('Please enter the 6 digits code sent to email')}</p>
      <Form.Group className="mb-3" controlId="formGroupEmail">
        <FormLabel className="font-SemiBold">{t("Enter Code")}</FormLabel>
        <div className={`flex-gap-2 justify-content-around`}>
          {Array.from({ length }, (_, index) => (
            <Form.Control
              key={index}
              type="text"
              maxLength={1}
              value={OTP[index]}
              onPaste={index === 0 ? handlePaste : undefined} // Handle paste only on the first input
              onChange={(e) => handleTextChange(e.target.value, index)}
              ref={(ref) => (inputRef.current[index] = ref)}
              className={`dimension-per-20 border border-solid focus-border-main text-center outline-none p-0`}
            />
          ))}
        </div>
        {validated && <div className={`invalid-feedback mt-2 ${(!OTP.join('') || validated) && 'd-block'}`}>
          {msgError}
        </div>}
      </Form.Group>
      <Button aria-label="Aria label" type="submit" className="btn-main w-100 mt-3">{t("Verify")}</Button>
      <div className='text-center font-13 text-main-color mt-3'>
        {isTimerActive ? (
          <span>{t('Resend code in')} {timer}{t('s')}</span>
        ) : (
          <span className='cursor-pointer' onClick={handleSendCode}>{t('Send code again?')}</span>
        )}
      </div>
    </Form>
  );
};

export default OTPInput;